const DocumentLinksPage = ({ title, intro, documents }) => {
	return (
		<main className="mt-25 w-full max-w-5xl px-6 py-12 md:mt-40">
			<h1 className="mb-10 font-serif text-4xl leading-[1.2] text-white uppercase md:text-5xl">{title}</h1>
			<div className="flex w-full flex-col gap-6 text-sm text-white md:text-base">
				<p>{intro}</p>
				<ul className="flex w-full flex-col gap-4">
					{documents.map((document) => (
						<li key={document.href} className="flex w-full flex-col gap-1 border-b border-white/20 pb-4">
							<span className="text-xs uppercase text-white/70 md:text-sm">Documento</span>
							<a
								href={document.href}
								target="_blank"
								rel="noopener noreferrer"
								className="text-lg font-bold uppercase underline underline-offset-4 md:text-xl">
								{document.label}
							</a>
						</li>
					))}
				</ul>
			</div>
		</main>
	);
};

export default DocumentLinksPage;
